/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Now_ButtonInputs */



/**
* | output |
* | --- |
* | "Publish Now" |
*
* @param {Iconik_Publish_Now_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_now_button = /** @type {((inputs?: Iconik_Publish_Now_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Now_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publier maintenant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Jetzt veröffentlichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblica ora")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опубликовать сейчас")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicar ahora")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("立即发布")
	if (locale === "ja") return /** @type {LocalizedString} */ ("今すぐ公開")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अब प्रकाशित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicar agora")
	return /** @type {LocalizedString} */ ("Publish Now")
});